var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contenidoNosotros"}},[_c('SectionNosotros1'),_c('SectionNosotros2'),_c('SectionNosotros3'),_c('SectionNosotros4')],1)}
var staticRenderFns = []

export { render, staticRenderFns }